import React from 'react';
import styled from 'styled-components';
import { Container, Form, Button } from 'react-bootstrap';
import { updatePriority } from '../../UserFunctions';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';

const Styles = styled.div`
    .overlay {
        position: absolute;
        top: 10px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
    }
`;

export class PriorityPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: '1',
            emergency: '1',
            waiting_period: '1',
            number_of_cancellation: '1',
            complexity: '1',
            age: '1',
            operation_time: '1',
            elective_priority: '1'
        }
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.updateState = this.updateState.bind(this);
    }

    onChange(e) {
      this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
      e.preventDefault();

      const priority = {
        id: 1,
        emergency: document.getElementById("emergency").value ,
        waiting_period: document.getElementById("waiting_period").value,
        number_of_cancellation: document.getElementById("number_of_cancellation").value,
        complexity: document.getElementById("complexity").value,
        age: document.getElementById("age").value,
        operation_time: document.getElementById('operation_time').value,
        elective_priority: document.getElementById('elective_priority').value
      };
      console.log(priority)
      updatePriority(priority).then(res => {
        if (res) {
          window.location.reload();
        }
        else {
            
        }
    })
    
  
  }

    updateState = state => {
        this.setState({ selectedRows: state.selectedRows });
      }


  render() {


    return (
      <Styles>
              <div className="overlay"></div>
                <Container>
        
                    <Form onSubmit={this.onSubmit}>
                         {/* NEED TO FIX THIS ONE! */}
                         <Form.Group controlId="emergency">
                            <Form.Label>Emergency:</Form.Label>
                            <Form.Control as="select">
                                <option>{null}</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="waiting_period">
                            <Form.Label>Waiting Period:</Form.Label>
                            <Form.Control as="select">
                                <option>{null}</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="number_of_cancellation">
                            <Form.Label>Number of Cancellation:</Form.Label>
                            <Form.Control as="select">
                                <option>{null}</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="complexity">
                            <Form.Label>Complexity:</Form.Label>
                            <Form.Control as="select">
                                <option>{null}</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="age">
                            <Form.Label>Age:</Form.Label>
                            <Form.Control as="select">
                                <option>{null}</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="operation_time">
                            <Form.Label>Operation Time:</Form.Label>
                            <Form.Control as="select">
                                <option>{null}</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </Form.Control>
                            </Form.Group>   
                            <Form.Group controlId="elective_priority">
                            <Form.Label>Elective Priority</Form.Label>
                            <Form.Control type="text" name="elective_priority" placeholder="Elective Priority List"/>
                        </Form.Group>                       
                        <Button variant="primary" type="submit">
                            Save Priority
                        </Button>
                    </Form>
                </Container>
      </Styles>
    )
  }
};
 
export default PriorityPage
